module.exports = __webpack_public_path__ + "img/vpn-proxy-master.395a425.png";